/** True when the node is part of the product tour overlay (step popover or skip modal). */
export function isProductTourUiNode(node: Node | null | undefined): boolean {
  if (!(node instanceof Element)) return false;
  return Boolean(
    node.closest('.product-tour-root, .product-tour-skip-layer')
  );
}
